import React, { useState, useRef, useEffect } from 'react';
import { Form } from 'react-bootstrap';

const matchesTicket = (ticket, query) => {
    const haystack = `${ticket.ref} ${ticket.subject} ${ticket.severity_label}`.toLowerCase();
    return haystack.includes(query.toLowerCase());
};

const TicketCombobox = ({ tickets, value, onChange, placeholder }) => {
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const filteredTickets = value.trim()
        ? tickets.filter(ticket => matchesTicket(ticket, value.trim()))
        : tickets;

    const handleSelect = (ticket) => {
        onChange(ticket.ref);
        setIsOpen(false);
    };

    return (
        <div ref={containerRef} style={{ position: 'relative' }}>
            <Form.Control
                type="text"
                value={value}
                onChange={(e) => {
                    onChange(e.target.value);
                    setIsOpen(true);
                }}
                onFocus={() => setIsOpen(true)}
                placeholder={placeholder}
                autoComplete="off"
                required
            />
            {isOpen && (
                <div
                    style={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        right: 0,
                        zIndex: 2000,
                        maxHeight: '220px',
                        overflowY: 'auto',
                        backgroundColor: '#fff',
                        border: '1px solid #ced4da',
                        borderRadius: '0.375rem',
                        boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.15)',
                        marginTop: '2px'
                    }}
                >
                    {filteredTickets.length === 0 ? (
                        <div className="px-3 py-2 text-muted">No matching tickets</div>
                    ) : (
                        filteredTickets.map(ticket => (
                            <div
                                key={ticket.id}
                                onMouseDown={(e) => {
                                    // mousedown fires before the input's blur/outside-click handler
                                    e.preventDefault();
                                    handleSelect(ticket);
                                }}
                                className="px-3 py-2"
                                style={{ cursor: 'pointer' }}
                                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f1f3f5'; }}
                                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                            >
                                <div className="fw-medium">{ticket.ref}</div>
                                <small className="text-muted">{ticket.subject} - {ticket.severity_label}</small>
                            </div>
                        ))
                    )}
                </div>
            )}
        </div>
    );
};

export default TicketCombobox;
